export const lessons = [
    { label: 'IPA', code: 'subject_ipa' },
    { label: 'IPS', code: 'subject_ips' },
    { label: 'Bahasa Indonesia', code: 'subject_bahasa_indonesia' },
    { label: 'Bahasa Inggris', code: 'subject_bahasa_inggris' },
    { label: 'Matematika', code: 'subject_matematika' },
    { label: 'Pendidikan Pancasila', code: 'subject_pendidikan_pancasila' },
    { label: 'Informatika', code: 'subject_informatika' },
    { label: 'PJOK', code: 'subject_pjok' },
    { label: 'Agama Islam', code: 'subject_agama_islam' },
    { label: 'Agama Kristen', code: 'subject_agama_kristen' },
    { label: 'Agama Katolik', code: 'subject_agama_katolik' },
    { label: 'Agama Hindu', code: 'subject_agama_hindu' },
    { label: 'Agama Buddha', code: 'subject_agama_buddha' },
    { label: 'Agama Khonghucu', code: 'subject_agama_khonghucu' },
    { label: 'Kepercayaan', code: 'subject_kepercayaan' },
    { label: 'Seni Tari', code: 'subject_seni_tari' },
    { label: 'Seni Musik', code: 'subject_seni_musik' },
    { label: 'Seni Rupa', code: 'subject_seni_rupa' },
    { label: 'Seni Teater', code: 'subject_seni_teater' },
    { label: 'Sosiologi', code: 'subject_sosiologi' },
    { label: 'Antropologi', code: 'subject_antropologi' },
    { label: 'Ekonomi', code: 'subject_ekonomi' },
    { label: 'Geografi', code: 'subject_geografi' },
    { label: 'Sejarah', code: 'subject_sejarah' },
    { label: 'Prakarya', code: 'subject_prakarya' },
    { label: 'IPAS', code: 'subject_ipas' },
    { label: 'Koding dan Kecerdasan Artifisial', code: 'subject_koding_dan_kecerdasan_artifisial' },
    { label: 'Teknik Konstruksi dan Perumahan', code: 'subject_teknik_konstruksi_dan_perumahan' },
    { label: 'Teknik Otomotif', code: 'subject_teknik_otomotif' },
    { label: 'Teknik Elektronika', code: 'subject_teknik_elektronika' },
    { label: 'Teknik Pesawat Udara', code: 'subject_teknik_pesawat_udara' },
    { label: 'Tenik Energi Surya, Hidro, dan Angin', code: 'subject_teknik_energi_surya_hidro_dan_angin' },
    { label: 'Teknik Konstruksi Kapal', code: 'subject_teknik_konstruksi_kapal' },
    { label: 'Teknik Ketenagalistrikan', code: 'subject_teknik_ketenagalistrikan' },
    { label: 'Teknik Geospasial', code: 'subject_teknik_geospasial' },
    { label: 'Teknik Geologi Pertambangan', code: 'subject_teknik_geologi_pertambangan' },
    { label: 'Layanan Kesehatan', code: 'subject_layanan_kesehatan' },
    { label: 'Agriteknologi Pengolahan Hasil Pertanian', code: 'subject_agriteknologi_pengolahan_hasil_pertanian' },
    { label: 'Manajemen Perkantoran dan Layanan Bisnis', code: 'subject_manajemen_perkantoran_dan_layanan_bisnis' },
    { label: 'Usaha Layanan Pariwisata', code: 'subject_usaha_layanan_pariwisata' },
    { label: 'Desain Komunikasi Visual', code: 'subject_desain_komunikasi_visual' },
    { label: 'Teknik Furniture', code: 'subject_teknik_furniture' },
    { label: 'Kuliner', code: 'subject_kuliner' },
    { label: 'Biologi', code: 'subject_biologi' },
    { label: 'Fisika', code: 'subject_fisika' },
    { label: 'Kimia', code: 'subject_kimia' },
    { label: 'Seni Budaya', code: 'subject_seni_budaya' },
    { label: 'Dasar-dasar Akuntansi dan Keuangan Lembaga', code: 'subject_dasar_dasar_akuntansi_dan_keuangan_lembaga' },
    { label: 'Dasar-dasar Animasi', code: 'subject_dasar_dasar_animasi' },
    { label: 'Dasar-dasar Broadcasting dan Perfilman', code: 'subject_dasar_dasar_broadcasting_dan_perfilman' },
    { label: 'Dasar-dasar Busana', code: 'subject_dasar_dasar_busana' },
    { label: 'Dasar-dasar Teknologi Farmasi', code: 'subject_dasar_dasar_teknologi_farmasi' },
    { label: 'Projek IPAS', code: 'subject_projek_ipas' },
    { label: 'Dasar-dasar Teknik Jaringan Komputer dan Telekomunikasi', code: 'subject_dasar_dasar_teknik_jaringan_komputer_dan_telekomunikasi' },
    { label: 'Dasar-dasar Nautika Kapal Niaga', code: 'subject_dasar_dasar_nautika_kapal_niaga' },
    { label: 'Dasar-dasar Nautika Kapal Penangkap Ikan', code: 'subject_dasar_dasar_nautika_kapal_penangkap_ikan' },
    { label: 'Dasar-dasar Kecantikan dan Spa', code: 'subject_dasar_dasar_kecantikan_dan_spa' },
    { label: 'Dasar-dasar Kehutanan', code: 'subject_dasar_dasar_kehutanan' },
    { label: 'Dasar-dasar Pekerjaan Sosial', code: 'subject_dasar_dasar_pekerjaan_sosial' },
    { label: 'Dasar-dasar Teknik Pengelasan dan Fabrikasi Logam', code: 'subject_dasar_dasar_teknik_pengelasan_dan_fabrikasi_logam' },
    { label: 'Dasar-dasar Perhotelan', code: 'subject_dasar_dasar_perhotelan' },
    { label: 'Dasar-dasar Agribisnis Perikanan', code: 'subject_dasar_dasar_agribisnis_perikanan' },
    { label: 'Dasar-dasar Teknik Perminyakan', code: 'subject_dasar_dasar_teknik_perminyakan' },
    { label: 'Dasar-dasar Pengembangan Perangkat Lunak dan Gim', code: 'subject_dasar_dasar_pengembangan_perangkat_lunak_dan_gim' },
    { label: 'Dasar-dasar Agribisnis Tanaman', code: 'subject_dasar_dasar_agribisnis_tanaman' },
    { label: 'Dasar-dasar Agribisnis Ternak', code: 'subject_dasar_dasar_agribisnis_ternak' },
    { label: 'Dasar-dasar Teknik Energi Terbarukan', code: 'subject_dasar_dasar_teknik_energi_terbarukan' },
    { label: 'Dasar-dasar Desain Pemodelan dan Informasi Bangunan', code: 'subject_dasar_dasar_desain_pemodelan_dan_informasi_bangunan' },
    { label: 'Dasar-dasar Kimia Analisa', code: 'subject_dasar_dasar_kimia_analisa' },
    { label: 'Dasar-dasar Konstruksi dan Perawatan Bangunan Sipil', code: 'subject_dasar_dasar_kontruksi_dan_perawatan_bangunan_sipil' },
    { label: 'Dasar-dasar Teknik Konstruksi Kapal', code: 'subject_dasar_dasar_teknik_konstruksi_kapal' },
    { label: 'Dasar-dasar Teknik Perawatan Gedung', code: 'subject_dasar_dasar_teknik_perawatan_gedung' },
    { label: 'Dasar-dasar Usaha Pertanian Terpadu', code: 'subject_dasar_dasar_usaha_pertanian_terpadu' },
    { label: 'Dasar-dasar Desain dan Produksi Kriya', code: 'subject_dasar_dasar_desain_dan_produksi_kriya' },
    { label: 'Dasar-dasar Seni Pertunjukan', code: 'subject_dasar_dasar_seni_pertunjukan' },
    { label: 'Dasar-dasar Seni Rupa', code: 'subject_dasar_dasar_seni_rupa' },
    { label: 'Dasar-dasar Teknik Logistik', code: 'subject_dasar_dasar_teknik_logistik' },
    { label: 'Dasar-dasar Teknik Mesin', code: 'subject_dasar_dasar_teknik_mesin' },
    { label: 'Dasar-dasar Teknik Tekstil', code: 'subject_dasar_dasar_teknik_tekstil' },
    { label: 'Dasar-dasar Teknik Geologi Pertambangan', code: 'subject_dasar_dasar_teknik_geologi_pertambangan' },
    { label: 'Dasar-dasar Pemasaran', code: 'subject_dasar_dasar_pemasaran' },
    { label: 'Dasar-dasar Teknik Kimia Industri', code: 'subject_dasar_dasar_teknik_kimia_industri' },
    { label: 'Dasar-dasar Teknik Laboratorium Medik', code: 'subject_dasar_dasar_teknik_laboratorium_medik' },
    { label: 'Dasar-dasar Konstruksi dan Perawatan Bangunan Sipil', code: 'subject_dasar_dasar_kontruksi_dan_perawatan_bangunan_sipil' },
    { label: 'Dasar-Dasar Teknika Kapal Penangkap Ikan', code: 'subject_dasar_dasar_teknika_kapal_penangkap_ikan' },
    { label: 'Konstruksi Jalan, Irigasi, dan Jembatan', code: 'subject_konstruksi_jalan_irigasi_dan_jembatan' },
    { label: 'Animasi', code: 'subject_animasi' },
    { label: 'Manajemen Logistik', code: 'subject_manajemen_logistik' },
    { label: 'Teknik Alat Berat', code: 'subject_teknik_alat_berat' },
    { label: 'Layanan Penunjang Keperawatan dan Caregiving', code: 'subject_layanan_penunjang_keperawatan_dan_caregiving' },
    { label: 'Dasar-Dasar Teknika Kapal Niaga', code: 'subject_dasar_dasar_teknika_kapal_niaga'},
];

export const classLevel = [
    { label: 'I', code: 'class_1' },
    { label: 'VII', code: 'class_7' },
    { label: 'II', code: 'class_2' },
    { label: 'VIII', code: 'class_8' },
    { label: 'III', code: 'class_3' },
    { label: 'IX', code: 'class_9' },
    { label: 'IV', code: 'class_4' },
    { label: 'X', code: 'class_10' },
    { label: 'V', code: 'class_5' },
    { label: 'XI', code: 'class_11' },
    { label: 'VI', code: 'class_6' },
    { label: 'XII', code: 'class_12' }
];

export const subjectsByLevel = {
    "level_sd": [
        "Agama Buddha",
        "Agama Hindu",
        "Agama Islam",
        "Agama Katolik",
        "Agama Khonghucu",
        "Agama Kristen",
        "Kepercayaan",
        "Bahasa Indonesia",
        "Bahasa Inggris",
        "IPAS",
        "Koding dan Kecerdasan Artifisial",
        "Matematika",
        "Pendidikan Pancasila",
        "PJOK",
        "Seni Musik",
        "Seni Rupa",
        "Seni Tari",
        "Seni Teater"
    ],
    "level_smp": [
        "Agama Buddha",
        "Agama Hindu",
        "Agama Islam",
        "Agama Katolik",
        "Agama Khonghucu",
        "Agama Kristen",
        "Kepercayaan",
        "Bahasa Indonesia",
        "Bahasa Inggris",
        "Informatika",
        "IPA",
        "IPS",
        "Koding dan Kecerdasan Artifisial",
        "Matematika",
        "Pendidikan Pancasila",
        "PJOK",
        "Prakarya",
        "Seni Musik",
        "Seni Rupa",
        "Seni Tari",
        "Seni Teater"
    ],
    "level_sma": [
        "Agama Buddha",
        "Agama Hindu",
        "Agama Islam",
        "Agama Katolik",
        "Agama Khonghucu",
        "Agama Kristen",
        "Kepercayaan",
        "Antropologi",
        "Bahasa Indonesia",
        "Bahasa Inggris",
        "Bahasa Jepang",
        "Bahasa Korea",
        "Bahasa Mandarin",
        "Biologi",
        "Ekonomi",
        "Fisika",
        "Geografi",
        "Informatika",
        "Kimia",
        "Koding dan Kecerdasan Artifisial",
        "Matematika",
        "Pendidikan Pancasila",
        "PJOK",
        "Prakarya",
        "Sejarah",
        "Seni Musik",
        "Seni Rupa",
        "Seni Tari",
        "Seni Teater",
        "Sosiologi"
    ],
    "level_smk": [
        "Agama Buddha",
        "Agama Hindu",
        "Agama Islam",
        "Agama Katolik",
        "Agama Khonghucu",
        "Agama Kristen",
        "Kepercayaan",
        "Agriteknologi Pengolahan Hasil Pertanian",
        "Animasi",
        "Bahasa Indonesia",
        "Bahasa Inggris",
        "Bahasa Jepang",
        "Bahasa Korea",
        "Bahasa Mandarin",
        "Dasar-dasar Agribisnis Perikanan",
        "Dasar-dasar Agribisnis Tanaman",
        "Dasar-dasar Agribisnis Ternak",
        "Dasar-dasar Akuntansi dan Keuangan Lembaga",
        "Dasar-dasar Animasi",
        "Dasar-dasar Broadcasting dan Perfilman",
        "Dasar-dasar Busana",
        "Dasar-dasar Desain dan Produksi Kriya",
        "Dasar-dasar Desain Pemodelan dan Informasi Bangunan",
        "Dasar-dasar Kecantikan dan Spa",
        "Dasar-dasar Kehutanan",
        "Dasar-dasar Kimia Analisa",
        "Dasar-dasar Konstruksi dan Perawatan Bangunan Sipil",
        "Dasar-dasar Nautika Kapal Niaga",
        "Dasar-dasar Nautika Kapal Penangkap Ikan",
        "Dasar-dasar Pekerjaan Sosial",
        "Dasar-dasar Pemasaran",
        "Dasar-dasar Pengembangan Perangkat Lunak dan Gim",
        "Dasar-dasar Perhotelan",
        "Dasar-dasar Seni Pertunjukan",
        "Dasar-dasar Seni Rupa",
        "Dasar-dasar Teknik Energi Terbarukan",
        "Dasar-dasar Teknik Geologi Pertambangan",
        "Dasar-dasar Teknik Jaringan Komputer dan Telekomunikasi",
        "Dasar-dasar Teknik Kimia Industri",
        "Dasar-dasar Teknik Konstruksi Kapal",
        "Dasar-dasar Teknik Laboratorium Medik",
        "Dasar-dasar Teknik Logistik",
        "Dasar-dasar Teknik Mesin",
        "Dasar-dasar Teknik Pengelasan dan Fabrikasi Logam",
        "Dasar-dasar Teknik Perawatan Gedung",
        "Dasar-dasar Teknik Perminyakan",
        "Dasar-dasar Teknik Tekstil",
        "Dasar-Dasar Teknika Kapal Niaga",
        "Dasar-Dasar Teknika Kapal Penangkap Ikan",
        "Dasar-dasar Teknologi Farmasi",
        "Dasar-dasar Usaha Pertanian Terpadu",
        "Desain Komunikasi Visual",
        "Informatika",
        "Koding dan Kecerdasan Artifisial",
        "Kontruksi Jalan, Irigasi dan Jembatan",
        "Kuliner",
        "Layanan Kesehatan",
        "Layanan Penunjang Keperawatan dan Caregiving",
        "Manajemen Logistik",
        "Manajemen Perkantoran dan Layanan Bisnis",
        "Matematika",
        "Pendidikan Pancasila",
        "PJOK",
        "Projek IPAS",
        "Sejarah",
        "Seni Musik",
        "Seni Rupa",
        "Seni Tari",
        "Seni Teater",
        "Teknik Alat Berat",
        "Teknik Elektronika",
        "Teknik Furniture",
        "Teknik Geologi Pertambangan",
        "Teknik Geospasial",
        "Teknik Ketenagalistrikan",
        "Teknik Konstruksi dan Perumahan",
        "Teknik Konstruksi Kapal",
        "Teknik Otomotif",
        "Teknik Pesawat Udara",
        "Tenik Energi Surya, Hidro, dan Angin",
        "Usaha Layanan Pariwisata"
    ],
    "level_diksus": [],
    "level_paud": []
};

export const allSubjectsForDisplay = [
    { label: 'Agama Buddha', code: 'subject_agama_buddha' },
    { label: 'Agama Hindu', code: 'subject_agama_hindu' },
    { label: 'Agama Islam', code: 'subject_agama_islam' },
    { label: 'Agama Katolik', code: 'subject_agama_katolik' },
    { label: 'Agama Khonghucu', code: 'subject_agama_khonghucu' },
    { label: 'Agama Kristen', code: 'subject_agama_kristen' },
    { label: 'Kepercayaan', code: 'subject_kepercayaan' },
    { label: 'Agriteknologi Pengolahan Hasil Pertanian', code: 'subject_agriteknologi_pengolahan_hasil_pertanian' },
    { label: 'Animasi', code: 'subject_animasi' },
    { label: 'Antropologi', code: 'subject_antropologi' },
    { label: 'Bahasa Indonesia', code: 'subject_bahasa_indonesia' },
    { label: 'Bahasa Inggris', code: 'subject_bahasa_inggris' },
    { label: 'Bahasa Jepang', code: 'subject_bahasa_jepang' },
    { label: 'Bahasa Korea', code: 'subject_bahasa_korea' },
    { label: 'Bahasa Mandarin', code: 'subject_bahasa_mandarin' },
    { label: 'Biologi', code: 'subject_biologi' },
    { label: 'Dasar-dasar Agribisnis Perikanan', code: 'subject_dasar_dasar_agribisnis_perikanan' },
    { label: 'Dasar-dasar Agribisnis Tanaman', code: 'subject_dasar_dasar_agribisnis_tanaman' },
    { label: 'Dasar-dasar Agribisnis Ternak', code: 'subject_dasar_dasar_agribisnis_ternak' },
    { label: 'Dasar-dasar Akuntansi dan Keuangan Lembaga', code: 'subject_dasar_dasar_akuntansi_dan_keuangan_lembaga' },
    { label: 'Dasar-dasar Animasi', code: 'subject_dasar_dasar_animasi' },
    { label: 'Dasar-dasar Broadcasting dan Perfilman', code: 'subject_dasar_dasar_broadcasting_dan_perfilman' },
    { label: 'Dasar-dasar Busana', code: 'subject_dasar_dasar_busana' },
    { label: 'Dasar-dasar Desain dan Produksi Kriya', code: 'subject_dasar_dasar_desain_dan_produksi_kriya' },
    { label: 'Dasar-dasar Desain Pemodelan dan Informasi Bangunan', code: 'subject_dasar_dasar_desain_pemodelan_dan_informasi_bangunan' },
    { label: 'Dasar-dasar Kecantikan dan Spa', code: 'subject_dasar_dasar_kecantikan_dan_spa' },
    { label: 'Dasar-dasar Kehutanan', code: 'subject_dasar_dasar_kehutanan' },
    { label: 'Dasar-dasar Kimia Analisa', code: 'subject_dasar_dasar_kimia_analisa' },
    { label: 'Dasar-dasar Konstruksi dan Perawatan Bangunan Sipil', code: 'subject_dasar_dasar_kontruksi_dan_perawatan_bangunan_sipil' },
    { label: 'Dasar-dasar Nautika Kapal Niaga', code: 'subject_dasar_dasar_nautika_kapal_niaga' },
    { label: 'Dasar-dasar Nautika Kapal Penangkap Ikan', code: 'subject_dasar_dasar_nautika_kapal_penangkap_ikan' },
    { label: 'Dasar-dasar Pekerjaan Sosial', code: 'subject_dasar_dasar_pekerjaan_sosial' },
    { label: 'Dasar-dasar Pemasaran', code: 'subject_dasar_dasar_pemasaran' },
    { label: 'Dasar-dasar Pengembangan Perangkat Lunak dan Gim', code: 'subject_dasar_dasar_pengembangan_perangkat_lunak_dan_gim' },
    { label: 'Dasar-dasar Perhotelan', code: 'subject_dasar_dasar_perhotelan' },
    { label: 'Dasar-dasar Seni Pertunjukan', code: 'subject_dasar_dasar_seni_pertunjukan' },
    { label: 'Dasar-dasar Seni Rupa', code: 'subject_dasar_dasar_seni_rupa' },
    { label: 'Dasar-dasar Teknik Energi Terbarukan', code: 'subject_dasar_dasar_teknik_energi_terbarukan' },
    { label: 'Dasar-dasar Teknik Geologi Pertambangan', code: 'subject_dasar_dasar_teknik_geologi_pertambangan' },
    { label: 'Dasar-dasar Teknik Jaringan Komputer dan Telekomunikasi', code: 'subject_dasar_dasar_teknik_jaringan_komputer_dan_telekomunikasi' },
    { label: 'Dasar-dasar Teknik Kimia Industri', code: 'subject_dasar_dasar_teknik_kimia_industri' },
    { label: 'Dasar-dasar Teknik Konstruksi Kapal', code: 'subject_dasar_dasar_teknik_konstruksi_kapal' },
    { label: 'Dasar-dasar Teknik Laboratorium Medik', code: 'subject_dasar_dasar_teknik_laboratorium_medik' },
    { label: 'Dasar-dasar Teknik Logistik', code: 'subject_dasar_dasar_teknik_logistik' },
    { label: 'Dasar-dasar Teknik Mesin', code: 'subject_dasar_dasar_teknik_mesin' },
    { label: 'Dasar-dasar Teknik Pengelasan dan Fabrikasi Logam', code: 'subject_dasar_dasar_teknik_pengelasan_dan_fabrikasi_logam' },
    { label: 'Dasar-dasar Teknik Perawatan Gedung', code: 'subject_dasar_dasar_teknik_perawatan_gedung' },
    { label: 'Dasar-dasar Teknik Perminyakan', code: 'subject_dasar_dasar_teknik_perminyakan' },
    { label: 'Dasar-dasar Teknik Tekstil', code: 'subject_dasar_dasar_teknik_tekstil' },
    { label: 'Dasar-Dasar Teknika Kapal Niaga', code: 'subject_dasar_dasar_teknika_kapal_niaga' },
    { label: 'Dasar-Dasar Teknika Kapal Penangkap Ikan', code: 'subject_dasar_dasar_teknika_kapal_penangkap_ikan' },
    { label: 'Dasar-dasar Teknologi Farmasi', code: 'subject_dasar_dasar_teknologi_farmasi' },
    { label: 'Dasar-dasar Usaha Pertanian Terpadu', code: 'subject_dasar_dasar_usaha_pertanian_terpadu' },
    { label: 'Desain Komunikasi Visual', code: 'subject_desain_komunikasi_visual' },
    { label: 'Ekonomi', code: 'subject_ekonomi' },
    { label: 'Fisika', code: 'subject_fisika' },
    { label: 'Geografi', code: 'subject_geografi' },
    { label: 'Informatika', code: 'subject_informatika' },
    { label: 'IPA', code: 'subject_ipa' },
    { label: 'IPAS', code: 'subject_ipas' },
    { label: 'IPS', code: 'subject_ips' },
    { label: 'Kimia', code: 'subject_kimia' },
    { label: 'Koding dan Kecerdasan Artifisial', code: 'subject_koding_dan_kecerdasan_artifisial' },
    { label: 'Kontruksi Jalan, Irigasi dan Jembatan', code: 'subject_konstruksi_jalan_irigasi_dan_jembatan' },
    { label: 'Kuliner', code: 'subject_kuliner' },
    { label: 'Layanan Kesehatan', code: 'subject_layanan_kesehatan' },
    { label: 'Layanan Penunjang Keperawatan dan Caregiving', code: 'subject_layanan_penunjang_keperawatan_dan_caregiving' },
    { label: 'Manajemen Logistik', code: 'subject_manajemen_logistik' },
    { label: 'Manajemen Perkantoran dan Layanan Bisnis', code: 'subject_manajemen_perkantoran_dan_layanan_bisnis' },
    { label: 'Matematika', code: 'subject_matematika' },
    { label: 'Pendidikan Pancasila', code: 'subject_pendidikan_pancasila' },
    { label: 'PJOK', code: 'subject_pjok' },
    { label: 'Prakarya', code: 'subject_prakarya' },
    { label: 'Projek IPAS', code: 'subject_projek_ipas' },
    { label: 'Sejarah', code: 'subject_sejarah' },
    { label: 'Seni Budaya', code: 'subject_seni_budaya' },
    { label: 'Seni Musik', code: 'subject_seni_musik' },
    { label: 'Seni Rupa', code: 'subject_seni_rupa' },
    { label: 'Seni Tari', code: 'subject_seni_tari' },
    { label: 'Seni Teater', code: 'subject_seni_teater' },
    { label: 'Sosiologi', code: 'subject_sosiologi' },
    { label: 'Teknik Alat Berat', code: 'subject_teknik_alat_berat' },
    { label: 'Teknik Elektronika', code: 'subject_teknik_elektronika' },
    { label: 'Teknik Furniture', code: 'subject_teknik_furniture' },
    { label: 'Teknik Geologi Pertambangan', code: 'subject_teknik_geologi_pertambangan' },
    { label: 'Teknik Geospasial', code: 'subject_teknik_geospasial' },
    { label: 'Teknik Ketenagalistrikan', code: 'subject_teknik_ketenagalistrikan' },
    { label: 'Teknik Konstruksi dan Perumahan', code: 'subject_teknik_konstruksi_dan_perumahan' },
    { label: 'Teknik Konstruksi Kapal', code: 'subject_teknik_konstruksi_kapal' },
    { label: 'Teknik Otomotif', code: 'subject_teknik_otomotif' },
    { label: 'Teknik Pesawat Udara', code: 'subject_teknik_pesawat_udara' },
    { label: 'Tenik Energi Surya, Hidro, dan Angin', code: 'subject_teknik_energi_surya_hidro_dan_angin' },
    { label: 'Usaha Layanan Pariwisata', code: 'subject_usaha_layanan_pariwisata' }
];